import React from "react";
import { Check, Phone, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const checklistItems = ["We plan work around sustainable workloads and reasonable hours, so people have time for life outside the office.", "We provide structured flexibility where possible, while still making sure client work is well managed and supported.", "We respect boundaries and the time people spend outside of work, instead of treating constant availability as normal.", "We are building a calm, professional environment where thoughtful work, clear priorities, and well-being all matter."];
export default function WhyChooseUs() {
  return <section data-section-id="261497" id="work-life-balance-that-is-real" className="bg-white text-foreground py-16 md:py-24 border-b border-border/40">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="order-2 lg:order-1">
            <div className="relative rounded-3xl overflow-hidden shadow-xl border border-border/60 bg-white p-3">
              <img src="https://stable-woodcock.10web.cloud/wp-content/uploads/2026/05/ChatGPT-Image-May-16-2026-09_16_32-AM.png" alt="People in a canoe on a calm northern lake, reflecting RiverBend's focus on sustainable work and life balance" className="w-full aspect-[4/3] lg:aspect-[5/4] object-cover rounded-2xl" loading="lazy" />

              <div className="absolute top-6 right-6 bg-primary-600 text-primary-foreground rounded-full px-4 py-2 text-xs font-medium shadow-lg">
                Genuine balance
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2 max-w-2xl lg:ml-auto">
            <div className="h-1 w-12 bg-secondary-500 mb-6 rounded-full" />

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default tracking-tight text-primary-600 leading-tight">
              Work-life balance that is real.
            </h2>

            <p className="mt-5 text-lg md:text-xl text-muted-foreground leading-relaxed font-default">
              We believe sustainable workloads, reasonable hours, and structured
              flexibility are not perks. They are part of how good work gets
              done. RiverBend is building a workplace where people can do
              meaningful professional work without burning out.
            </p>

            <ul className="space-y-4 mt-8">
              {checklistItems.map((item, i) => <li key={i} data-index={i} className="flex items-start gap-4 rounded-xl border border-border/70 bg-slate-50/80 p-4">
                  <div className="bg-secondary-100 rounded-lg p-1.5 shrink-0 mt-0.5">
                    <Check className="size-4 text-secondary-700 stroke-[3]" />
                  </div>

                  <span className="text-muted-foreground leading-relaxed text-base font-default">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="flex flex-col sm:flex-row gap-3 mt-9">
              <Button asChild size="lg" className="bg-primary-600 hover:bg-primary-700 text-primary-foreground rounded-md shadow-sm">
                <Link to="/TeamAndCareersPage">
                  <Phone className="size-4 mr-2" />
                  Join Our Team
                </Link>
              </Button>

              <Button asChild size="lg" variant="outline" className="border-primary-200 text-primary-600 hover:bg-primary-50 bg-transparent rounded-md">
                <Link to="/ContactPage">
                  <Mail className="size-4 mr-2" />
                  Contact Us
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}